import { render, staticRenderFns } from "./ToutiaoAd.vue?vue&type=template&id=8a0a9648&scoped=true"
import script from "./ToutiaoAd.vue?vue&type=script&lang=js"
export * from "./ToutiaoAd.vue?vue&type=script&lang=js"
import style0 from "./ToutiaoAd.vue?vue&type=style&index=0&id=8a0a9648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0a9648",
  null
  
)

export default component.exports